import React from 'react';

const LOGO_URL = '/manus-storage/logo-3d-optimized_a3d87dcf.webp';

interface Logo3DProps {
  size?: number;
  /** 'navbar' = compact brand mark, 'hero' = larger static brand mark */
  variant?: 'navbar' | 'hero';
  className?: string;
}

/**
 * Stable Northgate Web brand mark.
 *
 * The logo intentionally remains static: the original blue N mark stays
 * legible and avoids the disappearing/backface artifact caused by rotating
 * the raster mark through 180 degrees.
 */
export default function Logo3D({ size = 36, variant = 'navbar', className = '' }: Logo3DProps) {
  const isHero = variant === 'hero';

  return (
    <div
      className={`${isHero ? 'logo3d-hero' : 'logo3d-navbar'} ${className}`}
      style={{
        position: 'relative',
        width: size,
        height: size,
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center',
        isolation: 'isolate',
      }}
    >
      <img
        src={LOGO_URL}
        alt={isHero ? 'Northgate Web 3D Logo' : 'Northgate Web Logo'}
        loading={isHero ? 'eager' : 'lazy'}
        decoding="async"
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block',
          opacity: 1,
          visibility: 'visible',
          transform: 'none',
          backfaceVisibility: 'visible',
          filter: 'drop-shadow(0 0 7px rgba(37,99,235,0.38)) drop-shadow(0 4px 8px rgba(0,0,0,0.42))',
        }}
      />
      {isHero && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            inset: '-10%',
            zIndex: 0,
            borderRadius: '22%',
            background: 'radial-gradient(circle, rgba(37,99,235,0.18), transparent 68%)',
            pointerEvents: 'none',
          }}
        />
      )}
    </div>
  );
}
